import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { useInView } from '@/hooks/useInView';

const categorySlugMap: Record<string, string> = {
  '明星八卦': 'star-gossip',
  '综艺热点': 'variety-show',
  '影视追踪': 'film-tv',
  '社会热点': 'society',
  '音乐圈': 'music-circle',
};

export default function ArticleGrid() {
  const [ref, inView] = useInView(0.05);

  return (
    <section ref={ref} className={`py-14 md:py-20 px-4 md:px-6 bg-background-50 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="mb-10 md:mb-14">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-900 leading-tight">
          最新爆料
        </h2>
        <p className="mt-1 text-2xl md:text-4xl font-heading font-bold text-foreground-300">
          新鲜大瓜 · 持续追踪
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {articles.map((article, idx) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group rounded-xl border border-background-200/70 overflow-hidden bg-background-50 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            style={{ transitionDelay: `${idx * 80}ms` }}
          >
            <div className="relative h-48 md:h-52 overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute top-3 left-3" onClick={(e) => e.preventDefault()}>
                <Link
                  to={`/category/${categorySlugMap[article.category] || 'star-gossip'}`}
                  className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors inline-block"
                >
                  {article.category}
                </Link>
              </div>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors">
                {article.title}
              </h3>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万
                </span>
                <span className="whitespace-nowrap">{article.publishedAt}</span>
                <div className="flex items-center gap-1.5 ml-auto" onClick={(e) => e.preventDefault()}>
                  {article.tags.slice(0, 2).map((tag) => (
                    <Link
                      key={tag}
                      to={`/tag/${tag}`}
                      className="px-1.5 py-0.5 rounded-md bg-background-100 text-foreground-500 text-[10px] whitespace-nowrap hover:text-accent-500 hover:bg-accent-100/50 transition-colors inline-block"
                    >
                      #{tag}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
